module.exports = __webpack_public_path__ + "img/chemical02.50b38ef0.jpg";